var pills = {
    base: {
        appearance: "none",
        display: "inline-flex",
        alignItems: "center",
        lineHeight: 2,
        textDecoration: "none",
        height: "22px",
        width: "auto",
        borderRadius: 50,
        whiteSpace: "nowrap",
        fontFamily: "body",
        boxSizing: "border-box",
        maxWidth: "100%",
        "> *": {
            verticalAlign: "middle",
        },
        " .labelBox": {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            lineHeight: "inherit",
        },
    },
    variants: {
        look: {
            boldSolid: {
                color: "white",
                " .iconBox": {
                    color: "white",
                    opacity: 0.6,
                },
            },
            lightSolid: {
                color: "text",
            },
            lightOutlined: {
                color: "text",
                border: "1px solid",
            },
        },
        size: {
            sm: {
                fontSize: 0,
                height: "16px",
                lineHeight: "16px",
                padding: "0 8px",
            },
            md: {
                fontSize: 1,
                height: "22px",
                lineHeight: "22px",
                padding: "0 12px",
            },
            lg: {
                fontSize: 2,
                height: "25px",
                lineHeight: "25px",
                padding: "0 16px",
            },
        },
        tone: {},
        variant: {
            "boldSolid-primary": {
                backgroundColor: "primary.70",
            },
            "boldSolid-secondary": {
                backgroundColor: "black.60",
            },
            "boldSolid-success": {
                backgroundColor: "success.60",
            },
            "boldSolid-warning": {
                backgroundColor: "warning.60",
            },
            "boldSolid-critical": {
                backgroundColor: "critical.60",
            },
            "lightSolid-primary": {
                backgroundColor: "primary.10",
                " .iconBox": {
                    color: "primary.60",
                },
            },
            "lightSolid-secondary": {
                backgroundColor: "black.5",
                " .iconBox": {
                    color: "black.60",
                },
            },
            "lightSolid-success": {
                backgroundColor: "success.10",
                " .iconBox": {
                    color: "success.60",
                },
            },
            "lightSolid-warning": {
                backgroundColor: "warning.10",
                " .iconBox": {
                    color: "warning.60",
                },
            },
            "lightSolid-critical": {
                backgroundColor: "critical.10",
                " .iconBox": {
                    color: "critical.60",
                },
            },
            "lightOutlined-primary": {
                backgroundColor: "primary.10",
                borderColor: "primary.60",
                " .iconBox": {
                    color: "primary.60",
                },
            },
            "lightOutlined-secondary": {
                backgroundColor: "black.5",
                borderColor: "black.60",
                " .iconBox": {
                    color: "black.60",
                },
            },
            "lightOutlined-success": {
                backgroundColor: "success.10",
                borderColor: "success.60",
                " .iconBox": {
                    color: "success.60",
                },
            },
            "lightOutlined-warning": {
                backgroundColor: "warning.10",
                borderColor: "warning.60",
                " .iconBox": {
                    color: "warning.60",
                },
            },
            "lightOutlined-critical": {
                backgroundColor: "critical.10",
                borderColor: "critical.60",
                " .iconBox": {
                    color: "critical.60",
                },
            },
        },
    },
    defaultProps: {
        size: "md",
        look: "boldSolid",
        tone: "primary",
        variant: "boldSolid-primary",
    },
};
var pillIcons = {
    base: {},
    variants: {
        position: {},
        size: {
            sm: {
                fontSize: "10px",
                minWidth: "10px",
            },
            md: {
                fontSize: "12px",
                minWidth: "12px",
            },
            lg: {
                // placeholder until we have designs
                fontSize: "13px",
                minWidth: "13px",
            },
        },
        variant: {
            "left-sm": {
                marginRight: "4px",
                marginLeft: "-4px",
            },
            "right-sm": {
                marginLeft: "4px",
                marginRight: "-4px",
            },
            "left-md": {
                marginRight: "4px",
                marginLeft: "-7px",
            },
            "right-md": {
                marginLeft: "4px",
                marginRight: "-7px",
            },
            "left-lg": {
                marginRight: "4px",
                marginLeft: "-10px",
            },
            "right-lg": {
                marginLeft: "4px",
                marginRight: "-10px",
            },
        },
    },
    defaultProps: {
        size: "md",
        position: "left",
        variant: "left-lg",
    },
};

export { pillIcons, pills };
//# sourceMappingURL=pills.js.map
